












































































































































































import LazyHydrate from 'vue-lazy-hydration';
import { SfSelect, SfHeading, SfButton, SfLink } from '@storefront-ui/vue';
import { computed, defineComponent, onMounted, ref, ssrRef, useFetch, useRoute } from '@nuxtjs/composition-api';
import { CacheTagPrefix, useCache } from '@vue-storefront/cache';
import { usePageStore } from '~/stores/page';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import CategoryPagination from '~/modules/catalog/category/components/pagination/CategoryPagination.vue';
import { useCategory, useFacet, useUiHelpers, useUiState, } from '~/composables';
import { useAddToCart } from '~/helpers/cart/addToCart';
import { useWishlist } from '~/modules/wishlist/composables/useWishlist';
/* import useComparelist from '~/modules/comparelist/composables/useComparelist'; */
import { usePrice } from '~/modules/catalog/pricing/usePrice';
import { useCategoryContent } from '~/modules/catalog/category/components/cms/useCategoryContent';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';
import facetGetters from '~/modules/catalog/category/getters/facetGetters';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import CategoryNavbar from '~/modules/catalog/category/components/navbar/CategoryNavbar.vue';
import CategoryBreadcrumbs from '~/modules/catalog/category/components/breadcrumbs/CategoryBreadcrumbs.vue';
import type { ProductInterface } from '~/modules/GraphQL/types';
import type { SortingModel } from '~/modules/catalog/category/composables/useFacet/sortingOptions';
import type { Pagination } from '~/composables/types';
import type { Product } from '~/modules/catalog/product/types';
/* import CompareListBox from '~/components/ProductListPage/CompareListBox.vue'; */
import SvgImage from '~/components/General/SvgImage.vue';
import { KlevuEvents, KlevuFetch, search as klevuSearchModifier, sendSearchEvent, KlevuTypeOfSearch, KlevuKMCSettings, KlevuPackFetchResult } from "@klevu/core";

import $ from 'jquery';

export default defineComponent({
  name: 'catalogsearch',
  components: {
    CategoryPagination,
    CategoryEmptyResults: () => import('~/modules/catalog/category/components/CategoryEmptyResults.vue'),
    CategorySearchFilters: () => import('~/modules/catalog/category/components/filters/CategorySearchFilters.vue'),
    CategoryFilters: () => import('~/modules/catalog/category/components/filters/CategoryFilters.vue'),
    CmsContent: () => import('~/modules/catalog/category/components/cms/CmsContent.vue'),
    CategoryProductGrid: () => import('~/modules/catalog/category/components/views/CategoryProductGrid.vue'),
    CategoryProductList: () => import('~/modules/catalog/category/components/views/CategoryProductList.vue'),
    CategoryNavbar,
    CategoryBreadcrumbs,
    SfSelect,
    LazyHydrate,
    SfHeading,
    SkeletonLoader,
    /* CompareListBox, */
    SfLink,
    SfButton,
    SvgImage
  },
  transition: 'fade',
  setup() {
    const { routeData } = usePageStore();
    const { getContentData } = useCategoryContent();
    const { loadCategoryMeta } = useCategory();
    const { addTags } = useCache();
    const uiHelpers = useUiHelpers();
    const cmsContent = ref('');
    const isShowCms = ref(false);
    const isShowProducts = ref(false);
    const products = ssrRef<ProductInterface[]>([]);
    const sortBy = ref<SortingModel>({ selected: '', options: [] });
    const pagination = ref<Pagination>({});
    const productContainerElement = ref<HTMLElement | null>(null);
    const route = useRoute();
    const bgimage1Url = '/categorypage/camerasHeader.webp';
    const { toggleFilterSidebar, changeToCategoryListView, changeToCategoryGridView, isCategoryGridView, isFilterSidebarOpen, } = useUiState();
    const { load: loadWishlist, addItem: addItemToWishlistBase, isInWishlist, removeItem: removeItemFromWishlist, } = useWishlist();
    /* const { load: loadComparelist, addItem: addItemToComparelistBase, isInComparelist, removeItem: removeItemFromComparelist, } = useComparelist(); */
    const { result, search } = useFacet();
    const { addItemToCart } = useAddToCart();
    const categoryMeta = ref(null);
    const addItemToWishlist = async (product: Product) => { await (isInWishlist({ product })
        ? removeItemFromWishlist({ product })
        : addItemToWishlistBase({ product }));
    };
    /* const addItemToComparelist = async (product: Product) => { await (isInComparelist({ product })
        ? removeItemFromComparelist({ product })
        : addItemToComparelistBase({ product }));
    }; */
    const { activeCategory, loadCategoryTree } = useTraverseCategory();
    const activeCategoryName = computed(() => activeCategory.value?.name ?? '');
    const term = (route?.value?.query?.term) ? route.value.query.term : '';
    const searchTerm = (route?.value?.query?.term) ? route.value.query.term : '';
    
    const categoryUid = '';
    const { fetch } = useFetch(async () => {
      if (!activeCategory.value) {
        await loadCategoryTree();
      }

      const [content, categoryMetaData] = await Promise.all([
        getContentData(categoryUid as string),
        loadCategoryMeta({ category_uid: categoryUid}),
        search({ ...uiHelpers.getFacetsFromURL(), category_uid: categoryUid}),
      ]);

      categoryMeta.value = categoryMetaData;
      cmsContent.value = content?.cmsBlock?.content ?? '';
      isShowCms.value = content.isShowCms;
      isShowProducts.value = content.isShowProducts;
      /* if(result.value.input.sort == null || result.value.input.sort == ''){
        result.value.input.sort = 'quantity_and_stock_status-DESC';
      } */
      products.value = facetGetters.getProducts(result.value) ?? [];
      sortBy.value = facetGetters.getSortOptions(result.value);
      pagination.value = facetGetters.getPagination(result.value);

      const tags = [{ prefix: CacheTagPrefix.View, value: categoryUid }];
      const productTags = products.value.map((product) => ({
        prefix: CacheTagPrefix.Product,
        value: product.uid,
      }));

      addTags([...tags, ...productTags]);

      
      if(process.client){
            //@ts-ignore
            window.dataLayer = window.dataLayer || [];
            //@ts-ignore
            window.dataLayer.push({
              event: "klevu_search",
              klevu_search_results_num: products.value.length,        
            });
          }
    });

    const isPriceLoaded = ref(false);
    onMounted(async () => {
      loadWishlist();
      const { getPricesBySku } = usePrice();
      if (products.value.length > 0) {
        const skus = products.value.map((item) => item.sku);
        const priceData = await getPricesBySku(skus, pagination.value.itemsPerPage);
        products.value = products.value.map((product) => {
          const priceRange = priceData.items.find((item) => item.sku === product.sku)?.price_range;

          if (priceRange) {
            return {
              ...product,
              price_range: priceRange,
            };
          }

          return { ...product };
        });


      }

      isPriceLoaded.value = true;
      fetchKlevuSettings(searchTerm);

      $('body').on('click', '.sf-add-to-cart__button', function() {
        if(process.client){
                //@ts-ignore
                window.dataLayer = window.dataLayer || [];
                //@ts-ignore
                window.dataLayer.push({
                  event: "klevu_add_to_cart"
                });
              }
      });
    });

    const goToPage = (page: number) => {
      uiHelpers.changePage(page, false);
      fetch();      
      document.getElementById("layout").scrollIntoView();      
    };

    const doChangeItemsPerPage = (itemsPerPage: number) => {
      uiHelpers.changeItemsPerPage(itemsPerPage, false);
      goToPage(0);
    };

    const onReloadProducts = () => {
      goToPage(0);
      productContainerElement.value.scrollIntoView();
    };

    const doChangeSorting = (sort: string) => {
      uiHelpers.changeSorting(sort, false);
      onReloadProducts();
    };

    const pageMeta = {
      "meta_title": null,
      "meta_description": null,
      "meta_keywords": null,
      "name": "Midwest Photo Search results for:" + term,
    };

    const klevuSettings = ref({});
    const bannerKlevu = ref({});

    const fetchKlevuSettings = async (searchTerm) => {
      try {
        const settings = await KlevuKMCSettings();
        klevuSettings.value = settings;
        bannerKlevu.value = getBannerKlevu(searchTerm, settings);
      } catch (error) {
        console.log("Error fetching Klevu KMC Settings:", error);
      }

      KlevuFetch(klevuSearchModifier(searchTerm, { limit: 6 })).then((response) => {
        const dataToTransferFrontend = KlevuPackFetchResult(response)
        const totalResults = dataToTransferFrontend.queryResults[0]?.meta?.totalResultsFound ?? 0

        if (process.client) {
          KlevuEvents.search({
            term: searchTerm,
            totalResults: totalResults,
            typeOfSearch: KlevuTypeOfSearch.Default,
          })
        }
      })
    }

    const getBannerKlevu = (searchTerm, klevuSettings) => {
        if (!klevuSettings?.banner?.klevu_banner) {
            return null;
        }
      
        // Get current date without time for easier comparison
        const today = new Date();
        today.setHours(0, 0, 0, 0);
      
        // Find a matching banner with valid dates
        const banner = klevuSettings.banner.klevu_banner.find(b => {
            // Must match the search term in showForTerms
            if (!b.showForTerms || !b.showForTerms.includes(searchTerm)) {
                return false;
            }
          
            // Convert banner start/end dates to Date objects
            // Replacing "/" with "-" for better parsing support
            const startDate = new Date(b.startDate.replace(/\//g, "-"));
            const endDate = new Date(b.endDate.replace(/\//g, "-"));
            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(0, 0, 0, 0);
          
            // Check if today falls within the date range
            return today >= startDate && today <= endDate;
        });
      
        return (banner || null);
    };
    
    const sendClickEvent = ({ product }) => {
      console.log('sendClickEvent called!');
      if (process.client) {
        KlevuEvents.searchProductClick({
          product,
          searchTerm: Object(searchTerm)
        })
      }
    }

    return {
      isPriceLoaded,
      ...uiHelpers,
      toggleFilterSidebar,
      isCategoryGridView,
      changeToCategoryListView,
      changeToCategoryGridView,
      isFilterSidebarOpen,
      addItemToCart,
      addItemToWishlist,
      /* addItemToComparelist, */
      pagination,
      products,
      sortBy,
      isShowCms,
      isShowProducts,
      cmsContent,
      activeCategoryName,
      routeData,
      doChangeItemsPerPage,
      productContainerElement,
      categoryMeta,
      onReloadProducts,
      goToPage,
      term,
      categoryUid,
      bgimage1Url,
      doChangeSorting,
      pageMeta,
      bannerKlevu,
      sendClickEvent
    };
  },
  head() {
    return getMetaInfo(this.pageMeta);
  },
});
